// Components==============
import { useEffect, useState } from 'react';
// =========================

export default function useWrongAnimation() {
    const [wrong, setWrong] = useState(false);

    useEffect(() => {
        if (!wrong) return;

        const timeout = setTimeout(() => setWrong(false), 1000);
        return () => clearTimeout(timeout);
    }, [wrong]);

    return { wrong, setWrong };
}
